import React from "react";
import styled from "@emotion/styled";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { Home } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/material";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

const breadcrumbNameMap = {
  t_load: {
    title: "Teaching Load",
  },
  a_research: {
    title: "Active Research",
  },
  e_load: {
    title: "Active Extension Loads",
  },
  researches: {
    title: " Research",
  },
  new_researches: {
    title: " Request Research",
  },
  staff_overload: {
    title: " Staff Overload",
  },
  agreement: {
    title: "Contract Agreement",
  },
  part_time: {
    title: " Part Time Employee Contracts",
  },
  extensions: {
    title: " Extension Contracts",
  },
  offering: {
    title: "Course Offering",
  },
  setting: {
    title: " Settings",
  },
  security: {
    title: " Security",
  },
  appearances: {
    title: " Appearances",
  },
  research_management: {
    title: " Research Management",
  },
  course_management: {
    title: " Course Management",
  },
  addCourse: {
    title: " Add Course",
  },
  editCourse: {
    title: " Edit Course",
  },
  curriculumList: {
    title: " Curriculum List",
  },
  addCurriculum: {
    title: " Add Curriculum",
  },
  editCurriculum: {
    title: " Edit Curriculum",
  },
  office_management: {
    title: " Office Management",
  },
  addOffice: {
    title: " Add Office",
  },
  editOffice: {
    title: " Edit Office",
  },
  addHierarchy: {
    title: "Add Hierarchy",
  },
  position_management: {
    title: " Position Management",
  },
  addPosition: {
    title: " Add Position",
  },
  editPosition: {
    title: " Edit Position",
  },
  roles: {
    title: " Manage Roles",
  },
  courseReport: {
    title: " Course Report",
  },
  batchReport: {
    title: " Batch Report",
  },
  staffReport: {
    title: " Staff Report",
  },
  courseAssignment: {
    title: " Course Allocation",
  },
  constants: {
    title: " Constants ",
  },
  updateSection: {
    title: " Update Section ",
  },
  batch_management: {
    title: " Manage Batches",
  },
  calendar_management: {
    title: "Manage Calendar",
  },
  addGroup: {
    title: " Add Group",
  },
  update: {
    title: " Update",
  },
  register: {
    title: " Register ",
  },
  displayCalendar: {
    title: "Calendar Display",
  },
  addCalendar: {
    title: " Add Calendar",
  },
  updateCalendar: {
    title: " Update Calendar",
  },
  dashboard: {
    title: " Office Dashboard",
  },
  staff_management: {
    title: " Staff Management",
  },
  addStaff: {
    title: "Add Staff",
  },
  editStaff: {
    title: "Edit Staff",
  },
  staff_overloadOffice: {
    title: "Overload Approval",
  },
  part_timeOffice: {
    title: "Part-Time Approval",
  },
  extensionsOffice: {
    title: "Extension Load Approval",
  },
  owncourseassignment: {
    title: "Own Course Assignment",
  },
  requestcourses: {
    title: "Request Courses",
  },
  requestassignment: {
    title: "Request Assignment",
  },
  SWEG101: {
    title: " Edit Curriculum",
  },
  confirmMember: {
    title: "Confirm Member",
  },
  staff_agreements: {
    title: "Staff Agreements",
  },
  office_approval: {
    title: "Office Approvals",
  },
  system_setting: {
    title: "System Settings",
  },
  research_role: {
    title: "Research Role",
  },
  rank: {
    title: "Academic Ranks",
  },
  status: {
    title: "Staff Status",
  },
  hour: {
    title: "Hour Setting",
  },
  addStatus: {
    title: "Add Status",
  },
  editStatus: {
    title: "Edit Status",
  },
  courseOfferingCalendar: {
    title: "Course Offering Calendar",
  },
  outofbatch: {
    title: "Out Of Batch",
  },
  updateOffBatch: {
    title: "Update OffBatch",
  },
  extension: {
    title: "Extension Program",
  },
  history: {
    title: "History",
  },
  log: {
    title: "System Log",
  },
  functionality: {
    title: "System Features",
  },
  database: {
    title: "System Database",
  },
  agreementReport: {
    title: "Agreements Report",
  },
  rank_management: {
    title: " Rank Management",
  },
  addRank: {
    title: " Add Rank",
  },
  editRank: {
    title: " Edit Rank",
  },
  finance:{
    title:"Finance"
  }
};
const BreadcrumbsWrapper = styled.div`
  width: 100%;
  background-color: ${(props) => props.palette.background.bread};
  padding: 5px 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  border-radius: 8px;
  position: sticky;
  top: 0px;
  z-index: 99999;
`;
const BreadCrumbs = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const pathnames = pathname.split("/").filter((x) => x);
  // console.log(pathnames);
  const navigate = useNavigate();
  return (
    <BreadcrumbsWrapper palette={theme.palette}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {pathnames.length > 0 ? (
          <Link
            underline="hover"
            key="1"
            color="inherit"
            onClick={() => navigate("/")}
            component="button"
          >
            <Home fontSize="small" />
          </Link>
        ) : (
          <Typography underline="hover" key="1" color="inherit">
            {" "}
            <Home fontSize="small" />{" "}
          </Typography>
        )}
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;
          return isLast ? (
            <Typography key={name} color="text.primary" fontSize={14}>
              {breadcrumbNameMap[name].title}{" "}
            </Typography>
          ) : (
            <Link
              underline="hover"
              key={name}
              color="inherit"
              onClick={() => navigate(routeTo)}
              fontSize="14px"
              component="button"
            >
              {breadcrumbNameMap[name]?.title}
            </Link>
          );
        })}
      </Breadcrumbs>
    </BreadcrumbsWrapper>
  );
};

export default BreadCrumbs;
